import React, { useEffect, useState } from "react";

import { Container, Row, Modal, Col } from "reactstrap";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Spinner from 'reactstrap/lib/Spinner';

// Formik 
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

//Redux
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../../store/actions'

//components 
import CarouselBanner from "./banner"
import StoreList from "../../components/store/StoreList";
import { UserService } from "../../services/userService";
import { useSelector } from "react-redux";
import { ApiConstants } from "../../common/apiConstants";
import { ProductService } from '../../services/productService';
import ProductList from '../../components/products/ProductList';
import introJs from "intro.js";
import "intro.js/introjs.css";

export default function Home(props) {
  const [mAddInfo, setMAddInfo] = useState(false);
  const user = useSelector(x => x.Login.user);
  const userService = new UserService();
  const dispatch = useDispatch();
  const [shownProducts, setShownProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const productService = new ProductService();
  //formulario "completar datos personales"


  const initialValues = {
    fechaNacimiento: user ? new Date(user.fechaNacimiento).toISOString().substring(0, 10) : null,
    idGenero: user ? user.idGenero : "",
    tipoIdentificacion: user ? user.tipoIdentificacion : "",
    numeroDocumento: user ? user.numeroDocumento : "",
    telefono: user ? user.telefono : "",
  }

  const formValidation = Yup.object().shape({
    fechaNacimiento: Yup.string().required("requerido"),
    idGenero: Yup.string().required("requerido"),
    tipoIdentificacion: Yup.string().required("requerido"),
    numeroDocumento: Yup.string().required("requerido"),
    telefono: Yup.string().required("requerido"),
  });

  const onSubmit = async values => {
    try {
      let request = {
        ...user,
        ...values
      }
      console.log(JSON.stringify(request));
      request.idGenero = Number.parseInt(values.idGenero);
      console.log("Actualizacion de datos desde HOME")
      const response = await userService.updatePerson(request);

      if (response === 1)
        toastr.success("Datos actualizados");
      dispatch(loginSuccess(request));
      setMAddInfo(false);
    } catch {
      // dispatch(setLoading(false));
    }
    // dispatch(setLoading(false));
  }

  const getProductsByStore = async (filter) => {
    setLoading(true)
    let products = await productService.GetProductsMainScreen();
    products = products?.productosMasPopulares?.map(a => {return {productDetailModel:a}}).slice(0,12)

    setShownProducts(products ?? []);
    setLoading(false)
  }

  useEffect(() => {
    getProductsByStore();
    if (user && (!user.idGenero ||
      !user.tipoIdentificacion ||
      !user.numeroDocumento ||
      !user.telefono)) {
      setMAddInfo(false);
      //initialValues = user;

    }
  }, [])


 useEffect(() => {
  sessionStorage.removeItem('returnToChatShown');

  const yaVisto = localStorage.getItem("demo_asistente_visto");

  if (!yaVisto) {
    const boton = document.getElementById("boton-asistente");

    if (boton) {
      introJs()
        .setOptions({
          steps: [
            {
              element: "#boton-asistente",
              intro: `
                <div style="text-align: left;">
                  <h3>¡Bienvenido! 👋</h3>
                  <p><strong>Soy tu asistente virtual</strong> y estoy aquí para ayudarte a analizar el estado de tu piel.</p>
                  <p><strong>Haz clic en este botón</strong> para comenzar tu diagnóstico personalizado y descubrir los productos ideales para ti.</p>
                </div>
              `,
              position: "right"
            }
          ],
          overlayOpacity: 0.9,
          tooltipClass: "anuncio-chat", // Clase personalizada
          highlightClass: "custom-highlight",
          showStepNumbers: false,
          showBullets: false,
          showButtons: true,
          nextLabel: "¡Empecemos!",
          doneLabel: "Listo",
          exitOnOverlayClick: false,
          exitOnEsc: true
        })
        .start();

      localStorage.setItem("demo_asistente_visto", "true");
    }
  }
}, []);


return (
  <React.Fragment>
    <div
      className="page-content no-scrollbar"
      style={{
        position: "relative",
        backgroundColor: "#f8f9f9",
        minHeight: "100%",
        overflowY: "auto"
      }}
    >
      {/* Imagen de fondo con transparencia */}
      <div
        style={{
          background: "#f8f9f9",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: 0,
        }}
      />

      {/* Contenido por delante del fondo */}
      <div style={{ position: "relative", zIndex: 1 }}>

        {/* Hero Banner 
        <div
          style={{
            minHeight: "500px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "2rem 3rem",
            color: "white",
            textAlign: "center"
          }}
        >
          <div
            style={{
              backgroundColor: "#B9AEA4",
              padding: "2rem",
              borderRadius: "1rem",
              maxWidth: "600px"
            }}
          >
            <img
              src="/images/Bastet_logo.png"
              alt="Bastet IA"
              style={{
                width: "120px",
                borderRadius: "1rem",
                marginBottom: "1rem"
              }}
            />
            <h2 style={{ color: "white" }}>Bienvenid@ a BASTET</h2>
            <h5 style={{ color: "white", fontWeight: "300" }}>Tienda Dermatológica</h5>
            <p style={{ marginTop: "1rem", color: "#f0f3f4" }}>
              Tecnología y ciencia para tu piel. Somos una tienda especializada en productos dermatológicos, 
              respaldados por inteligencia artificial y visión artificial para brindarte una experiencia personalizada, efectiva y moderna.
            </p>
          </div>
        </div> */}

        <div>
            <img
                src="/images/home_bastet.jpg"
                alt="Banner 2"
                style={{
                    maxWidth: "100%",
                    maxHeight: "500px",
                    objectFit: "contain",
                    margin: "0 auto",
                    display: "block"
                }}
            />
        </div>

        {/* Carrusel */}
        <Row>
          <CarouselBanner />
        </Row>


        {/* Modal */}
        <Modal isOpen={mAddInfo}>
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              Antes de continuar a realizar compras en Fanero, por favor actualice la siguiente información de su perfil.
            </h5>
            <button onClick={() => setMAddInfo(false)} type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={formValidation}>
              <Form>
                <div className="form-group">
                  <label htmlFor="tipoIdentificacion" className="control-label">Tipo de identificación</label>
                  <Field as="select" className="form-control" name="tipoIdentificacion" id="tipoIdentificacion" required>
                    <option value="CC">Cédula de ciudadanía</option>
                    <option value="CE">Cédula de Extrangería</option>
                  </Field>
                  <ErrorMessage name="tipoIdentificacion" />
                </div>

                <div className="form-group">
                  <label htmlFor="numeroDocumento" className="control-label">Numero de documento</label>
                  <Field name="numeroDocumento" id="numeroDocumento" className="form-control" type="text" required />
                  <ErrorMessage name="numeroDocumento" />
                </div>

                <div className="form-group">
                  <label htmlFor="fechaNacimiento" className="control-label">Fecha de nacimiento</label>
                  <Field name="fechaNacimiento" id="fechaNacimiento" type="date" max={new Date().toISOString().substring(0, 10)} className="form-control" required />
                  <ErrorMessage name="fechaNacimiento" />
                </div>

                <div className="form-group">
                  <label htmlFor="idGenero" className="control-label">Género</label>
                  <Field as="select" className="form-control" name="idGenero" id="idGenero">
                    <option value="0">Femenino</option>
                    <option value="1">Masculino</option>
                  </Field>
                  <ErrorMessage name="idGenero" />
                </div>

                <div className="form-group">
                  <label htmlFor="telefono" className="control-label">Celular</label>
                  <Field name="telefono" id="telefono" type="text" className="form-control" required />
                  <ErrorMessage name="telefono" />
                </div>

                <div className="mt-4">
                  <button className="btn btn-primary btn-block waves-effect waves-light" type="submit">Actualizar</button>
                </div>
              </Form>
            </Formik>
          </div>
        </Modal>

        {/* Productos */}
        <Container fluid>
          <Row>
            {shownProducts.length === 0 ? null : <h3 className="col-md-12 text-center mt-5 vendidos">LO MÁS VENDIDO</h3>}
            <Col md="12">
              {loading
                ? <Spinner color="dark" style={{ marginTop: "10%", marginLeft: "50%" }} />
                : <ProductList products={shownProducts || []} />
              }
            </Col>
          </Row>
        </Container>

      </div>
    </div>
  </React.Fragment>
);
}
